import { ToastrService } from "ngx-toastr";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { catchError } from "rxjs/internal/operators/catchError";
import { throwError } from "rxjs/internal/observable/throwError";
import { AppService } from "./app.service";
import { finalize } from "rxjs/internal/operators/finalize";
import { AuthenticationService } from "./authorization/authentication.service";
import { TokenService } from "./authorization/token.service";
import { environment } from "@env/environment";
import { showToastr } from "@shared/common";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
  HttpEvent,
} from "@angular/common/http";
import { EMPTY } from "rxjs/internal/observable/empty";

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    private toastr: ToastrService,
    private service: AppService,
    private tokenService: TokenService,
    private authenticationService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue;

    if (
      request.headers.get("Authorization") == undefined &&
      currentUser &&
      currentUser.AccessToken
    ) {
      if (this.tokenService.isTokenExpired(currentUser.AccessToken)) {
        this.authenticationService.signout();

        return EMPTY;
      }

      request = request.clone({
        headers: request.headers.set(
          "Authorization",
          `Bearer ${currentUser.AccessToken}`
        ),
      });
    }

    if (this.service.turnOffBlockUIOnce) {
      // setTimeout(() => {
      //   this.service.blockUI = true;
      this.service.turnOffBlockUIOnce = false;
      // });
    } else if (
      !this.service.turnOffBlockUI &&
      request.url !== environment.configFile
    ) {
      setTimeout(() => (this.service.blockUI = true));
    }

    if (location.protocol === "https:") {
      request = request.clone({
        url: request.url.replace("http://", "https://"),
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let message = "";

        if (error.message.includes("api.ipregistry.co")) return;

        if (error.statusText === "Unknown Error") {
          message = "Servidor no disponible";
        } else {
          if (error.status === 401) {
            this.authenticationService.signout();
            return;
          }
          message = error?.error?.detail;

          if (!message) message = "Error interno del servidor";
        }

        showToastr(this.toastr, message, "error");

        let errorMessage = "";

        if (!environment.production) {
          if (error.error instanceof ErrorEvent) {
            console.log("this is client side error");
            errorMessage = `Error: ${error.error.message}`;
          } else {
            console.log("this is server side error");
            errorMessage = `Error Code: ${error.status},  Message: ${error.message}`;
          }

          console.log(errorMessage);
        }

        setTimeout(() => (this.service.blockUI = false));
        return throwError(error);
      }),
      finalize(() => {
        setTimeout(() => (this.service.blockUI = false));
      })
    );
  }
}
